// dependancys
import React, { useEffect } from "reactn";
import { useHistory } from "react-router-dom";

// components
import { SecurityContainer } from "./Security.styled";
import { InfoContainer } from "../../../../_common/containers/containers.styled";
import Icon from "../../../../_common/icons/ReturnIcons";
import ThumbsUpIcon from "../../../../../images/thumbs-up.svg";
import Error from "../../../../_common/error/Error";

// hooks
import profileHooks from "../../../../../hooks/profileHooks";

const Security = () => {
    const { values, moneyUser } = profileHooks();
    const history = useHistory();

    return (
        <SecurityContainer>
            {values.passwordReset && (
                <InfoContainer shiny className="flex">
                    <img className="icon thumbs-up" src={ThumbsUpIcon} alt="" />
                    <h5 className="password-success">Your password has been updated</h5>
                </InfoContainer>
            )}
            {moneyUser && (
                <Error
                    errorHeading="Password"
                    errorText="Your account is associated with an An Post Money Account. For security reasons, your password can only be reset by following the ‘forgotten password’ link in your An Post Money app."
                ></Error>
            )}
            {values.userIsVerified && !moneyUser && (
                <InfoContainer>
                    <h4 className="h6">Password</h4>
                    <p className="mb0">*********</p>
                    <button
                        type="button"
                        className="infoContainer__edit"
                        onClick={() => {
                            history.push("/Profile/edit-password");
                        }}
                        aria-label="Edit Password"
                    >
                        <span className="edit__text">Edit</span> <Icon src="editIcon" />
                    </button>
                </InfoContainer>
            )}
        </SecurityContainer>
    );
};

export default Security;
Security.propTypes = {};
